'use client'

import { useState } from 'react'

interface ProductDescriptionProps {
	description: string
}

export default function ProductDescription({ description }: ProductDescriptionProps) {
	const [isExpanded, setIsExpanded] = useState(false)

	return (
		<div className="mb-5">
			<p className={`${!isExpanded ? 'line-clamp-3' : ''}`}>{description}</p>
			{description.length > 150 && (
				<button onClick={() => setIsExpanded(!isExpanded)} className="cursor-pointer text-link underline mt-2">
					{isExpanded ? 'Voir moins' : 'Voir plus'}
				</button>
			)}
		</div>
	)
}
